import { render, staticRenderFns } from "./SidebarTabAttachments.vue?vue&type=template&id=12367a1f&scoped=true"
import script from "./SidebarTabAttachments.vue?vue&type=script&lang=js"
export * from "./SidebarTabAttachments.vue?vue&type=script&lang=js"
import style0 from "./SidebarTabAttachments.vue?vue&type=style&index=0&id=12367a1f&prod&lang=scss&scoped=true"
import style1 from "./SidebarTabAttachments.vue?vue&type=style&index=1&id=12367a1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12367a1f",
  null
  
)

export default component.exports